
const assessmentInboxes = [
    {
        "uuid":"3",
        "createdOn":"2021-08-12T08:20:10.000Z",
        "appType":"initial",
        "phase":"inspectionArrangement",
        "activity":"inspectionArrangement_S10",
        "customerNo":"00003",
        "customerName":"黑松股份有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080204",
        "sampling":"Y",
        "onSiteInspection":"Y",
        "samplingPrinciple":"產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品，如:大包裝中有個別小顆單包裝之乾酪 或奶油、乳脂(奶油球)等，則應至少隨機自兩個大包裝中",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            }
        ],
        "remainingDays":1
    },
    {
        "uuid":"4",
        "urgent":true,
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"inspectionArrangement",
        "activity":"inspectionArrangement_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080205",
        "defaultArea":"north",
        "inspectionDateOrManDay": "inspectionDate",
        "inspectors":[],
        "sampleInfos":[
            {
                "product":"杏仁玄米餅",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "product":"Natural Benefits 食安生技-椰子汁",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-15T08:20:10.000Z",
            },
            {
                "product":"桂圓四物飲",
                "testType":"原料",
                "testName":"桂圓四物飲-原料1",
                "testItems":"真菌毒素-赭麴毒素A,真菌毒素-棒麴毒素",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":false,
                "samplingDate":"2021-10-21T08:20:10.000Z",
            }
        ],
        "preInspectionInspectors":[
            {
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "samplingDate":"2021-10-15T08:20:10.000Z",
            }
        ],
        "inspectionDates":[
            {
                "inspectionDate":"2021-10-19T08:20:10.000Z"
            }
        ]
    },
    {
        "uuid":"4-1",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"inspectionArrangement",
        "activity":"inspectionArrangement_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080200",
        "defaultArea":"north",
        "inspectionDateOrManDay": "manDay",
        "inspectors":[],
        "sampleInfos":[
            {
                "product":"杏仁玄米餅",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "product":"Natural Benefits 食安生技-椰子汁",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-15T08:20:10.000Z",
            },
            {
                "product":"桂圓四物飲",
                "testType":"原料",
                "testName":"桂圓四物飲-原料1",
                "testItems":"真菌毒素-赭麴毒素A,真菌毒素-棒麴毒素",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":false,
                "samplingDate":"2021-10-21T08:20:10.000Z",
            }
        ],
        "preInspectionInspectors":[
            {
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "samplingDate":"2021-10-15T08:20:10.000Z",
            }
        ],
        "manDay": 4
    },
    {
        "uuid":"5",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"sampling",
        "activity":"sampling_S10",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080206",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ]
    },
    {
        "uuid":"6",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"sampling",
        "activity":"sampling_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080207",
        "samplingPrinciple":"產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品，如:大包裝中有個別小顆單包裝之乾酪 或奶油、乳脂(奶油球)等",
        "sampleInfos":[
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ]
    },
    {
        "uuid":"7",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"sampling",
        "activity":"sampling_S30",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080201",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ]
    },
    {
        "uuid":"8",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"sampling",
        "activity":"sampling_S40",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080208",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z"
            }
        ],
        "remainingDays":5
    },
    {
        "uuid":"9",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"inspection",
        "activity":"inspection_S10",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080209",
        "plannedInspectionDates":["2021-10-13T08:20:10.000Z","2021-10-15T08:20:10.000Z"],
        "inspectionDates":[
            {"inspectionDate":"2021-10-13T08:00:00.000Z"},
            {"inspectionDate":"2021-10-15T08:00:00.000Z"}
        ],
        "inspectionItems": []
    },
    {
        "uuid":"10",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"inspection",
        "activity":"inspection_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080210",
        "inspectionDates":[
            {"inspectionDate":"2021-10-13"},
            {"inspectionDate":"2021-10-15"}
        ]
    },
    {
        "uuid":"11",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"initial",
        "phase":"inspection",
        "activity":"inspection_S40",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080212",
        "ncrs":[
            {"carNo":"INS01-01", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"],"observation":"碳酸鈣550g/包,未涵蓋使用範圍","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
            "correctionHistories":[
                {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
            ]},
            {"carNo":"INS01-02", "regulations":["里仁細則5.10","里仁細則6.2.1"],"observation":"秤添加物電子秤CL-P011(1.8kg),內校300g","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認已修改完成"},
            {"carNo":"INS01-03", "regulations":["里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"],"observation":"2樓洗手消毒亦有多隻果蠅","correctionActionPlan":"1.安全衛生課已會同消毒廠商進行加強消毒。\n2.平時以次氯酸水通水管以減少果蠅孳生風險並加強該作業區的清潔","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認完成改善"}
        ]
    },
    {
        "uuid":"12",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"followUp",
        "phase":"inspection",
        "activity":"inspection_S50",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080213",
        "inspectionReportType":"list",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "productChangeInspectionKeyNote":"1.員工衛生新進食品從業人員應先經醫療機構健康檢查合格後，始得聘僱；雇主每年應主動辦理健康檢查至少一次。\n" +
                "2.員工教育訓練：新進食品從業人員應接受適當之教育訓練，使其執行能力符合生產、衛生及品質管理之要求；在職從業人員，應定期接受食品安全、衛生及品質管理之教育訓練，並作成紀錄。",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames":["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "ncrs":[
            {"no":"INS01-01","ncrType":"secondary", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"],"observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"no":"INS01-02","ncrType":"secondary", "regulations":["里仁細則5.10","里仁細則6.2.1"],"observationDesc":"秤添加物電子秤CL-P011(1.8kg),內校300g","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認已修改完成"},
            {"no":"INS01-03","ncrType":"secondary", "regulations":["里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"],"observationDesc":"2樓洗手消毒亦有多隻果蠅","correctionActionPlan":"1.安全衛生課已會同消毒廠商進行加強消毒。\n2.平時以次氯酸水通水管以減少果蠅孳生風險並加強該作業區的清潔","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認完成改善"}
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ]
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ]}
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.14",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.15",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.16",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.17"
                        },
                        ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.10"
                        }
                        ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.14",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.15",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.16",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.17",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.18",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.19",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.20"
                        },
                        ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.9"
                        }
                      ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.14",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.15",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.16",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.17"
                        }
                        ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"9.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "uuid":"13",
        "createdOn":"2021-08-14T08:20:10.000Z",
        "appType":"initial",
        "phase":"assessmentReview",
        "activity":"assessmentReview_S10",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080211",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004",
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40",
                "unqualifiedReason": "賽滅寧0.5PPM(0.1PPM)"
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
            }
        ],
        "ncrs":[
            {
                "type":"secondary",
                "no":"INS01-01",
                "itemCode": "1.1",
                "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                "nextInspectionFocus":true,
                "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                "ncImprovement":"online",
                "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                "evaluateCorrectiveAction":"agree",
                "evaluateContent":"確認已改善",
                "reviewResults":[],
                "estimatedImprovementDate": "2022-01-13T00:00:00.000z",
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "type":"secondary",
                "no":"INS01-02",
                "itemCode": "1.2",
                "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                "nextInspectionFocus":true,
                "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                "ncImprovement":"online",
                "evaluateCorrectiveAction":"agree",
                "evaluateContent":"確認已改善",
                "reviewResults":[],
                "estimatedImprovementDate": "2022-01-13T00:00:00.000z",
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "type":"secondary",
                "no":"INS01-03",
                "itemCode": "1.3",
                "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                "nextInspectionFocus":true,
                "referencedRegulations":["GHP附表一.一.(三)"],
                "ncImprovement":"online",
                "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                "evaluateCorrectiveAction":"improve",
                "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                "reviewResults":[],
                "estimatedImprovementDate": "2022-01-13T00:00:00.000z",
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
    },
    {
        "uuid":"13.1",
        "createdOn":"2021-08-14T08:20:10.000Z",
        "appType":"initial",
        "phase":"assessmentReview",
        "activity":"assessmentReview_S10",
        "customerNo":"00003",
        "customerName":"黑松股份有限公司(紙本回覆)",
        "assessmentPlace":"台東廠",
        "no":"A21081211",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004",
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40",
                "unqualifiedReason": "賽滅寧0.5PPM(0.1PPM)"
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
            }
        ],
        "ncrs":[
            {
                "type":"secondary",
                "no":"INS01-01",
                "itemCode": "1.1",
                "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                "nextInspectionFocus":true,
                "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                "ncImprovement":"paper",
                "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                "evaluateCorrectiveAction":"agree",
                "evaluateContent":"確認已改善",
                "reviewResults":[],
                "estimatedImprovementDate": "2022-01-13T00:00:00.000z",
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "type":"secondary",
                "no":"INS01-02",
                "itemCode": "1.2",
                "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                "nextInspectionFocus":true,
                "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                "ncImprovement":"paper",
                "evaluateCorrectiveAction":"agree",
                "evaluateContent":"確認已改善",
                "reviewResults":[],
                "estimatedImprovementDate": "2022-01-13T00:00:00.000z",
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "type":"secondary",
                "no":"INS01-03",
                "itemCode": "1.3",
                "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                "nextInspectionFocus":true,
                "referencedRegulations":["GHP附表一.一.(三)"],
                "ncImprovement":"paper",
                "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                "evaluateCorrectiveAction":"improve",
                "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                "reviewResults":[],
                "estimatedImprovementDate": "2022-01-13T00:00:00.000z",
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
    },
    {
        "uuid":"14",
        "createdOn":"2021-08-14T08:20:10.000Z",
        "appType":"initial",
        "phase":"assessmentReview",
        "activity":"assessmentReview_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080214",
        "reviewer":"李大森",
        "question":"擬申請衛生證明之製造廠如通過第二級品管驗證經核發相關證明在案，得於該證明效期內向本署提出該製造廠產品之衛生證明申請，免實地查核",
        "questionReplyHistories": [
            {"createdOn":"2021-08-14T08:10:00.000Z", "question":"CAR編號 INS01-01 Google Fi 推出端對端加密通話的詳細內容", "replyOn":"2021-08-15T08:00:00.000Z", "responder":"蔡阿明","replyContent":"除了所有電話方案都包含的 VPN 和垃圾電話封鎖功能外，Google Fi 即將推出端對端加密通話，在無線產業中開創先河"}
        ],
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "productChangeInspection": "說明...",
            "otherSupplement": "說明...",
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "ncrs":[
            {"no":"INS01-01", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"],"observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"no":"INS01-02", "regulations":["里仁細則5.10","里仁細則6.2.1"],"observationDesc":"秤添加物電子秤CL-P011(1.8kg),內校300g","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認已修改完成"},
            {"no":"INS01-03", "regulations":["里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"],"observationDesc":"2樓洗手消毒亦有多隻果蠅","correctionActionPlan":"1.安全衛生課已會同消毒廠商進行加強消毒。\n2.平時以次氯酸水通水管以減少果蠅孳生風險並加強該作業區的清潔","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認完成改善"}
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "sunny",
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "arrivalTime": "2021-09-13T16:00:00.000Z",
                    "departureTime": "2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ],
                    "weather": "rainy",
                }
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        },
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004",
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40",
                "unqualifiedReason": "賽滅寧0.5PPM(0.1PPM)"
            }
        ],
    },
    {
        "uuid":"15",
        "createdOn":"2021-08-15T08:20:10.000Z",
        "appType":"initial",
        "phase":"assessmentReview",
        "activity":"assessmentReview_S30",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080215",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認",
            "manufacturingProcess": "製程......\n......\n......\n......"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                    "status": "improved",
                    "comments": "說明......"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                    "status": "notImproved",
                    "comments": "說明......"
                }
            ],
            "productChangeInspection": "品變編號說明......",
            "otherSupplement": "漏開缺失說明......",
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "verify": "compliance",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "addedNcrs":[
            {
                "itemCode": "1.3",
                "observation": "建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                "nextInspectionFocus": true,
                "reviewResult": "correct",
                "comment": "未落實執行現場施工品質抽查驗",
            }
        ],
        "previousNcrs":[
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"3.3",
                "ncrDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "inspectorConfirmImprovement": "improved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            },
            {
                "appNo":"A20080111",
                "type":"secondary",
                "inspectionItem":"6.1",
                "ncrDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "inspectorConfirmImprovement": "notImproved",
                "inspectorDesc": "稽核員說明......",
                "reviewerImplementationStatuses": [
                    {"reviewer": "委員1", "implementationStatus": "improved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員2", "implementationStatus": "notImproved", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                    {"reviewer": "委員3", "implementationStatus": "noNeedTrack", "reviewDesc": "審查說明 審查說明 審查說明 審查說明 "},
                ],
            }
        ],
        "inspectionItems":[
            {
                "section":"01",
                "items":[
                    {
                        "itemCode":"1.1",
                        "result":"Y",
                        "observation":"全面品質管理的運作主要是利用計劃、實施、查核及改善的管理循環模式，加以落實。",
                        "createNcr":true,
                        "carNo":"INS01-01"
                    },
                    {
                        "itemCode":"1.2",
                        "result":"N",
                        "observation":"建立品質保證系統並制定監造計畫，並落實執行現場施工品質抽查驗",
                        "createNcr":true,
                        "carNo":"INS01-02"
                    },
                    {
                        "itemCode":"1.3",
                        "result":"Y",
                    },
                    {
                        "itemCode":"1.4",
                        "result":"notApplicable"
                    },
                    {
                        "itemCode":"1.5",
                    }
                ]
            },
            {
                "section":"02",
                "items":[
                    {
                        "itemCode":"2.1",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.2",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.3",
                        "result":"N"
                    },
                    {
                        "itemCode":"2.4",
                        "result":"Y"
                    },
                    {
                        "itemCode":"2.5",
                    }
                ]
            },
            {
                "section":"03",
                "items":[
                    {
                        "itemCode":"3.1"
                    },
                    {
                        "itemCode":"3.2"
                    },
                    {
                        "itemCode":"3.3"
                    },
                    {
                        "itemCode":"3.4"
                    },
                    {
                        "itemCode":"3.5"
                    },
                    {
                        "itemCode":"3.6",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.7",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.8",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.9",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.10",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.11",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.12",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.13",
                        "result":"Y"
                    },
                    {
                        "itemCode":"3.14"
                    }
                ]
            },
            {
                "section":"04",
                "items":[
                    {
                        "itemCode":"4.1"
                    },
                    {
                        "itemCode":"4.2"
                    },
                    {
                        "itemCode":"4.3"
                    },
                    {
                        "itemCode":"4.4"
                    },
                    {
                        "itemCode":"4.5"
                    },
                    {
                        "itemCode":"4.6"
                    },
                    {
                        "itemCode":"4.7"
                    },
                    {
                        "itemCode":"4.8"
                    },
                    {
                        "itemCode":"4.9"
                    },
                    {
                        "itemCode":"4.10"
                    },
                    {
                        "itemCode":"4.11"
                    },
                    {
                        "itemCode":"4.12"
                    },
                    {
                        "itemCode":"4.13"
                    },
                    {
                        "itemCode":"4.14"
                    },
                    {
                        "itemCode":"4.15"
                    },
                    {
                        "itemCode":"4.16"
                    },
                    {
                        "itemCode":"4.17"
                    },
                ]
            },
            {
                "section":"05",
                "items":[
                    {
                        "itemCode":"5.1"
                    },
                    {
                        "itemCode":"5.2"
                    },
                    {
                        "itemCode":"5.3"
                    },
                    {
                        "itemCode":"5.4"
                    },
                    {
                        "itemCode":"5.5"
                    },
                    {
                        "itemCode":"5.6"
                    },
                    {
                        "itemCode":"5.7"
                    },
                    {
                        "itemCode":"5.8"
                    },
                    {
                        "itemCode":"5.9"
                    },
                    {
                        "itemCode":"5.10"
                    },
                ]
            },
            {
                "section":"06",
                "items":[
                    {
                        "itemCode":"6.1"
                    },
                    {
                        "itemCode":"6.2"
                    },
                    {
                        "itemCode":"6.3"
                    },
                    {
                        "itemCode":"6.4"
                    },
                    {
                        "itemCode":"6.5"
                    },
                    {
                        "itemCode":"6.6"
                    },
                    {
                        "itemCode":"6.7"
                    },
                    {
                        "itemCode":"6.8"
                    },
                    {
                        "itemCode":"6.9"
                    },
                    {
                        "itemCode":"6.10"
                    },
                    {
                        "itemCode":"6.11"
                    },
                    {
                        "itemCode":"6.12"
                    },
                    {
                        "itemCode":"6.13"
                    },
                    {
                        "itemCode":"6.14"
                    },
                    {
                        "itemCode":"6.15"
                    },
                    {
                        "itemCode":"6.16"
                    },
                    {
                        "itemCode":"6.17"
                    },
                    {
                        "itemCode":"6.18"
                    },
                    {
                        "itemCode":"6.19"
                    },
                    {
                        "itemCode":"6.20"
                    },
                ]
            },
            {
                "section":"07",
                "items":[
                    {
                        "itemCode":"7.1"
                    },
                    {
                        "itemCode":"7.2"
                    },
                    {
                        "itemCode":"7.3"
                    },
                    {
                        "itemCode":"7.4"
                    },
                    {
                        "itemCode":"7.5"
                    },
                    {
                        "itemCode":"7.6"
                    },
                    {
                        "itemCode":"7.7"
                    },
                    {
                        "itemCode":"7.8"
                    },
                    {
                        "itemCode":"7.9"
                    }
                ]
            },
            {
                "section":"08",
                "items":[
                    {
                        "itemCode":"8.1"
                    },
                    {
                        "itemCode":"8.2"
                    },
                    {
                        "itemCode":"8.3"
                    },
                    {
                        "itemCode":"8.4"
                    },
                    {
                        "itemCode":"8.5"
                    },
                    {
                        "itemCode":"8.6"
                    },
                    {
                        "itemCode":"8.7"
                    },
                    {
                        "itemCode":"8.8"
                    },
                    {
                        "itemCode":"8.9"
                    },
                    {
                        "itemCode":"8.10"
                    },
                    {
                        "itemCode":"8.11"
                    },
                    {
                        "itemCode":"8.12"
                    },
                    {
                        "itemCode":"8.13"
                    },
                    {
                        "itemCode":"8.14"
                    },
                    {
                        "itemCode":"8.15"
                    },
                    {
                        "itemCode":"8.16"
                    },
                    {
                        "itemCode":"8.17"
                    }
                ]
            },
            {
                "section":"09",
                "items":[
                    {
                        "itemCode":"9.1"
                    },
                    {
                        "itemCode":"9.2"
                    },
                    {
                        "itemCode":"9.3"
                    },
                ]
            }
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewerConclusions":[
            {"reviewer":"王小明","reviewConclusion":"approve"},
            {"reviewer":"王大同","reviewConclusion":"improvement"},
        ],
        "improvementWeeks":3,
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid":"16",
        "createdOn":"2021-08-16T08:20:10.000Z",
        "appType":"initial",
        "phase":"assessmentReview",
        "activity":"assessmentReview_S40",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080216",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "reviewMeetingDate":"2021-10-16T08:00:00.000Z",
        "resolutionNo":"20211016-03",
        "resolution":"approve",
        "addIrregularInspection":true,
        "howManyMonths":5,
        "earlyWarning":"Y",
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "comment":"賦予事物靈魂有兩大要素，一是名字，二是色彩，若以一句話形容adicolor，大概會是「運動穿搭與藝術的總和」",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "comment":"以網路上實測來看，晚第5代一個多月上市的支線系列👉Stepback 2，評價可比正代系列還高",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"observation",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewResult":"accept",
                "comment":"已改善",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "comment":"CP值高的中階鞋款",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ]
            }
        ],
        "samplingPrinciple":"(一)產品之單位完整包裝重量(體積)小於單次微生物檢驗所需之 取樣量者，其採樣件數應酌量增加，儘量取至檢驗需求之最低 取樣量以上。 (二)無獨立包裝之散裝販售食品，應平均取樣及均勻混合後再分成 所需之件數(n)，至少應取至檢驗需求之最低取樣量以上。",
        "otherAttentions":[
            {"otherAttention":"武陵農場一年一度的櫻花季，將在明年2月12日登場，11月1日早上8點半，開放散客預約住宿，短短5分鐘將近2000間的房間，全被預訂一空", "reviewer":"王小明"},
            {"otherAttention":"多選用新鮮食品，配料及調味料需留意有效期限及保存條件，不使用來路不明的食材，也要避免剩餘菜餚反覆加熱食用", "reviewer":"王大同"},
            {"otherAttention":"所有分店食品良好衛生規範準則自主管理檢查表1"},
            {"otherAttention":"所有分店食品良好衛生規範準則自主管理檢查表2"},
            {"otherAttention":"所有分店食品良好衛生規範準則自主管理檢查表"}
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "17",
        "createdOn": "2021-08-17T08:20:10.000Z",
        "appType": "initial",
        "phase": "assessmentDecision",
        "activity": "assessmentDecision_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080217",
        "resolution": "approve",
        "resolutionNo": "20211016-03",
        "addIrregularInspection":true,
        "howManyMonths":5,
        "earlyWarning":"Y",
        "additionalCharge": false,
        "additionalChargeItems": [],
        "reviewMeetingDate": "2021-10-16T08:00:00.000Z",
        "samplingPrinciple": "採樣原則......",
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "newAttentions": [
            {"otherAttention": "提醒客戶其他注意事項....."}
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "inspectionDescription": "此次查驗依審定會議決議，需增加不定期追蹤查驗，相關費用將由  貴公司支付",
        "nextInspectionFocus": "(一)\t0000/00/00查驗不符所提出之相關矯正措施執行狀況，列入下次查驗重點。\n" +
            "(二)\t觀察事項/審定會議決議事項，列入下次查驗重點。",
        "otherAttention": "(一)\t使用「慈悅國際股份有限公司」名義評鑑通過之產品外包裝、網站或相關文宣設計完成後，須送本公司審核，通過後方可印製。\n" +
            "(二)\t如客戶基本資料、評鑑場所、評鑑產品、原料等變更，與原申請所填內容不符，請提出異動申請供本公司審查。\n" +
            "(三)\t凡通過評鑑者，每年須執行追蹤查驗，以延續其有效性，相關費用請參照「慈悅國際評鑑費用表」。",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"transportation",
                "amountDefault":1600,
                "amountModified":1600
            },
            {
                "item":"labelAnnual",
                "amountDefault":1200,
                "amountModified":1200
            },
            {
                "item":"others",
                "amountDefault":2100,
                "amountModified":2100
            }
        ],
        "customerProductCount": 12,
        "leezenProductCount": 8,
        "semiFinishedProductCount": 2,
        "assessmentPlaceProductionLineCount": 2,
        "assessmentPlaceProductCount":5,
        "inspectionManDay":2.5,
        "actualInspectionManDay": 3,
        "suggestionsToAuditor": [
            {
                "reviewer": "委員1",
                "suggestion": "建議事項............"
            },
            {
                "reviewer": "委員2",
                "suggestion": "建議事項............"
            },
        ],
    },
    {
        "uuid": "17.1",
        "createdOn": "2021-08-17T08:20:10.000Z",
        "appType": "initial",
        "phase": "assessmentDecision",
        "activity": "assessmentDecision_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080317",
        "resolution": "approve",
        "resolutionNo": "20211016-03",
        "addIrregularInspection":true,
        "howManyMonths":5,
        "earlyWarning":"Y",
        "additionalCharge": false,
        "additionalChargeItems": [],
        "reviewMeetingDate": "2021-10-16T08:00:00.000Z",
        "samplingPrinciple": "採樣原則......",
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "newAttentions": [
            {"otherAttention": "提醒客戶其他注意事項....."}
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "inspectionDescription": "此次查驗依審定會議決議，需增加不定期追蹤查驗，相關費用將由  貴公司支付",
        "nextInspectionFocus": "(一)\t0000/00/00查驗不符所提出之相關矯正措施執行狀況，列入下次查驗重點。\n" +
            "(二)\t觀察事項/審定會議決議事項，列入下次查驗重點。",
        "otherAttention": "(一)\t使用「慈悅國際股份有限公司」名義評鑑通過之產品外包裝、網站或相關文宣設計完成後，須送本公司審核，通過後方可印製。\n" +
            "(二)\t如客戶基本資料、評鑑場所、評鑑產品、原料等變更，與原申請所填內容不符，請提出異動申請供本公司審查。\n" +
            "(三)\t凡通過評鑑者，每年須執行追蹤查驗，以延續其有效性，相關費用請參照「慈悅國際評鑑費用表」。",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "amountReceivedItems":[
            {
                "item":"management",
                "amount":1000
            },
            {
                "item":"onSiteAudit",
                "amount":2000
            },
            {
                "item":"certificate",
                "amount":1500
            },
            {
                "item":"transportation",
                "amount":1600
            },
            {
                "item":"labelAnnual",
                "amount":1200
            }
        ],
        "customerProductCount": 12,
        "leezenProductCount": 8,
        "semiFinishedProductCount": 2,
        "assessmentPlaceProductionLineCount": 2,
        "assessmentPlaceProductCount":5,
        "inspectionManDay":2.5,
        "actualInspectionManDay": 3,
        "suggestionsToAuditor": [
            {
                "reviewer": "委員1",
                "suggestion": "建議事項............"
            },
            {
                "reviewer": "委員2",
                "suggestion": "建議事項............"
            },
        ],
    },
    {
        "uuid": "18",
        "createdOn": "2021-08-18T08:20:10.000Z",
        "appType": "initial",
        "phase": "assessmentDecision",
        "activity": "assessmentDecision_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080218",
        "resolution": "reject",
        "description": "說明......",
        "resolutionNo": "20211016-03",
        "reviewMeetingDate": "2021-10-16T08:00:00.000Z",
        "samplingPrinciple": "採樣原則......",
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "newAttentions": [
            {"otherAttention": "提醒客戶其他注意事項....."}
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "nonCompliance": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第OOOO 條，有下列情形:\n" +
            "(一)\t申請評鑑產品『產品名稱OOO』之生產或製程OOOOOOOO未符合本公司規定及主管機關相關法規，且情節重大。\n" +
            "(二)\t因OOOOOOOOO之事由，致書面審查六個月內未完成補件、改善或不符合規定，或書面審查後三個月內無法進行實地查驗。\n" +
            "(三)\t經xxxx/xx/xx通知補正或限期改善，無正當理由屆期未補正或改善。\n" +
            "(四)\t產品『產品名稱OOO』(有效日期xxxx/xx/xx)或產品『產品名稱OOO』所用之原料『OOOO』(有效日期xxxx/xx/xx)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準。\n" +
            "(五)\t自xxxx/xx/xx申請案受理之次日起，因可歸責客戶之事由逾一年未結案。\n" +
            "(六)\t申請評鑑產品『產品名稱OOO』不符合本公司受理範圍。\n" +
            "(七)\t於xxxx/xx/xx通知繳交各項評鑑費用，經催繳超過十五天仍未繳交。\n" +
            "(八)\t未遵守申請書聲明之義務，OOOOOOOOO，其情節重大或經本公司xxxx/xx/xx通知，仍未如期完成改善。",
        "noticeAndCorrection": "(一)\t已發生之費用OOOO元，請於xxxx/xx/xx前繳清，恕無法退還。\n" +
            "(二)\t待上述相關不符合事項完成改善或補正後，再向本公司重新提出申請。",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"transportation",
                "amountDefault":1600,
                "amountModified":1600
            },
            {
                "item":"labelAnnual",
                "amountDefault":1200,
                "amountModified":1200
            },
            {
                "item":"others",
                "amountDefault":2100,
                "amountModified":2100
            }
        ],
        "customerProductCount": 12,
        "leezenProductCount": 8,
        "semiFinishedProductCount": 2,
        "assessmentPlaceProductionLineCount": 2,
        "assessmentPlaceProductCount":5,
        "inspectionManDay":2.5,
        "actualInspectionManDay": 3,
        "suggestionsToAuditor": [
            {
                "reviewer": "委員1",
                "suggestion": "建議事項............"
            },
            {
                "reviewer": "委員2",
                "suggestion": "建議事項............"
            },
        ],
    },
    {
        "uuid": "19",
        "createdOn": "2021-08-19T08:20:10.000Z",
        "appType": "initial",
        "phase": "assessmentDecision",
        "activity": "assessmentDecision_S20",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080219",
        "resolution": "reject",
        "resolutionNo": "20211016-03",
        "nonCompliance": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第OOOO 條，有下列情形:\n" +
            "(一)\t申請評鑑產品『產品名稱OOO』之生產或製程OOOOOOOO未符合本公司規定及主管機關相關法規，且情節重大。\n" +
            "(二)\t因OOOOOOOOO之事由，致書面審查六個月內未完成補件、改善或不符合規定，或書面審查後三個月內無法進行實地查驗。\n" +
            "(三)\t經xxxx/xx/xx通知補正或限期改善，無正當理由屆期未補正或改善。\n" +
            "(四)\t產品『產品名稱OOO』(有效日期xxxx/xx/xx)或產品『產品名稱OOO』所用之原料『OOOO』(有效日期xxxx/xx/xx)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準。\n" +
            "(五)\t自xxxx/xx/xx申請案受理之次日起，因可歸責客戶之事由逾一年未結案。\n" +
            "(六)\t申請評鑑產品『產品名稱OOO』不符合本公司受理範圍。\n" +
            "(七)\t於xxxx/xx/xx通知繳交各項評鑑費用，經催繳超過十五天仍未繳交。\n" +
            "(八)\t未遵守申請書聲明之義務，OOOOOOOOO，其情節重大或經本公司xxxx/xx/xx通知，仍未如期完成改善。",
        "noticeAndCorrection": "(一)\t已發生之費用OOOO元，請於xxxx/xx/xx前繳清，恕無法退還。\n" +
            "(二)\t待上述相關不符合事項完成改善或補正後，再向本公司重新提出申請。",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ],
        "customerProductCount": 12,
        "leezenProductCount": 8,
        "semiFinishedProductCount": 2,
        "assessmentPlaceProductionLineCount": 2,
        "assessmentPlaceProductCount":5,
        "inspectionManDay":2.5,
        "actualInspectionManDay": 3,
        "lessonPlans": [
            {
                "reviewer": "王大同",
                "lessonPlanContent": "料應以能夠使最高管理階層的資訊與食品安全管理系統所陳述的目標相關聯的方式展現"
            },
            {
                "reviewer": "李小華",
                "lessonPlanContent": "完整登錄食品履歷，快速對應食安風暴， 輕鬆上傳非追不可、團膳等公有雲平台。 提供供應商、原物料、農產品溯源、驗收管理等模組，全面打造完整食品安全管理環境"
            }
        ],
        "timeComplianceRate": "onTime",
        "suggestionsToAuditor": [
            {
                "reviewer": "委員1",
                "suggestion": "建議事項............"
            },
            {
                "reviewer": "委員2",
                "suggestion": "建議事項............"
            },
        ],
        "reviewMeetingDate": "2021-10-16T08:00:00.000Z",
        "samplingPrinciple": "採樣原則......",
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "newAttentions": [
            {"otherAttention": "提醒客戶其他注意事項....."}
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "20",
        "createdOn": "2021-08-20T08:20:10.000Z",
        "appType": "initial",
        "phase": "assessmentDecision",
        "activity": "assessmentDecision_S30",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080220",
        "resolution": "reject",
        "resolutionNo": "20211016-03",
        "nonCompliance": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第OOOO 條，有下列情形:\n" +
            "(一)\t申請評鑑產品『產品名稱OOO』之生產或製程OOOOOOOO未符合本公司規定及主管機關相關法規，且情節重大。\n" +
            "(二)\t因OOOOOOOOO之事由，致書面審查六個月內未完成補件、改善或不符合規定，或書面審查後三個月內無法進行實地查驗。\n" +
            "(三)\t經xxxx/xx/xx通知補正或限期改善，無正當理由屆期未補正或改善。\n" +
            "(四)\t產品『產品名稱OOO』(有效日期xxxx/xx/xx)或產品『產品名稱OOO』所用之原料『OOOO』(有效日期xxxx/xx/xx)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準。\n" +
            "(五)\t自xxxx/xx/xx申請案受理之次日起，因可歸責客戶之事由逾一年未結案。\n" +
            "(六)\t申請評鑑產品『產品名稱OOO』不符合本公司受理範圍。\n" +
            "(七)\t於xxxx/xx/xx通知繳交各項評鑑費用，經催繳超過十五天仍未繳交。\n" +
            "(八)\t未遵守申請書聲明之義務，OOOOOOOOO，其情節重大或經本公司xxxx/xx/xx通知，仍未如期完成改善。",
        "noticeAndCorrection": "(一)\t已發生之費用OOOO元，請於xxxx/xx/xx前繳清，恕無法退還。\n" +
            "(二)\t待上述相關不符合事項完成改善或補正後，再向本公司重新提出申請。",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ],
        "customerProductCount": 12,
        "leezenProductCount": 8,
        "semiFinishedProductCount": 2,
        "assessmentPlaceProductionLineCount": 2,
        "assessmentPlaceProductCount":5,
        "inspectionManDay":2.5,
        "actualInspectionManDay": 3,
        "lessonPlans": [
            {
                "reviewer": "王大同",
                "lessonPlanContent": "料應以能夠使最高管理階層的資訊與食品安全管理系統所陳述的目標相關聯的方式展現"
            },
            {
                "reviewer": "李小華",
                "lessonPlanContent": "完整登錄食品履歷，快速對應食安風暴， 輕鬆上傳非追不可、團膳等公有雲平台。 提供供應商、原物料、農產品溯源、驗收管理等模組，全面打造完整食品安全管理環境"
            }
        ],
        "timeComplianceRate": "onTime",
        "suggestionsToAuditor": [
            {
                "reviewer": "委員1",
                "suggestion": "建議事項............"
            },
            {
                "reviewer": "委員2",
                "suggestion": "建議事項............"
            },
        ],
        "reviewMeetingDate": "2021-10-16T08:00:00.000Z",
        "samplingPrinciple": "採樣原則......",
        "addSampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
        "followUpRequests":[
            {
                "carNo":"INS01-01",
                "ncrType":"primary",
                "checkItems":["02-1","04-2"],
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "nextInspectionFocus":true,
                "reviewResult":"correct",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-01",
                    "itemCode": "1.1",
                    "observationDesc":"碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["里仁細則5.10","里仁細則6.2.1"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-02",
                "ncrType":"secondary",
                "checkItems":["03-1"],
                "observation":"客戶提供之評鑑場所平面圖與實際看到者不一致",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs": {
                    "type": "secondary",
                    "no": "INS01-01",
                    "itemCode": "1.1",
                    "observationDesc": "碳酸鈣99.95 Suprapur®. REACH(歐盟關於化學品註 ... 建議的貯存溫度, 看產品標籤",
                    "nextInspectionFocus": true,
                    "referencedRegulations": ["里仁細則5.10", "里仁細則6.2.1"],
                    "ncImprovement": "online",
                    "correctionActionPlan": "由工程主辦機關(監造單位)建立品質保證系統,當監測發現CCP點失控或偏離管制界限時，需要採取矯正措施的行動，確保任何不安全的食品都能被攔除",
                    "evaluateCorrectiveAction": "agree",
                    "evaluateContent": "確認已改善",
                    "reviewResults": [],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "carNo":"INS01-03",
                "ncrType":"secondary",
                "checkItems":["06-1","06-2"],
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                    {
                        "reviewer":"王大同",
                        "reviewResult":"correct",
                        "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流"
                    }
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-02",
                    "itemCode": "1.2",
                    "observationDesc":"實衛生管理工作，確保產品在良好環境下產製，使食品品質及其安定性等各項管制作. 業得以有效進行。",
                    "nextInspectionFocus":true,
                    "correctionActionPlan":"核項目及觀察注意事項，評鑑結果應能顯示全數合格及缺失改善完成",
                    "referencedRegulations":["里仁細則5.10","慈悅第三部分 評鑑作業流程3.3.1"],
                    "ncImprovement":"online",
                    "evaluateCorrectiveAction":"agree",
                    "evaluateContent":"確認已改善",
                    "reviewResults":[],
                    "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            },
            {
                "checkItems":["06-3"],
                "ncrType":"secondary",
                "observation":"原材料進貨時沒有驗收紀錄",
                "nextInspectionFocus":true,
                "reviewResult":"track",
                "estimatedImprovementDate": "2021-01-13T00:00:00.000Z",
                "reviewersOpinions":[
                    {
                        "reviewer":"王小明",
                        "nextInspectionFocus":true,
                        "reviewResult":"track",
                        "comment":"Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了"
                    },
                ],
                "ncrs":{
                    "type":"secondary",
                    "no":"INS01-03",
                    "itemCode": "1.3",
                    "observationDesc":"程序書提供範例僅供參考，其中的條件、頻率或數字應以業者實際操作流程而適當 ... 目的:為建立本廠醬油產品製程及品質管制作業程序。",
                    "nextInspectionFocus":true,
                    "referencedRegulations":["GHP附表一.一.(三)"],
                    "ncImprovement":"online",
                    "correctionActionPlan":"稽核完成後，由食品安全決策小組召集稽核人員及受稽核單位，舉行結束會議，請稽核人員對稽核缺失進行報告，受稽核單位對稽核報告確認無誤，雙方當場於稽核查檢紀錄表簽字，受稽核單位於一個月內回覆內部稽核異常處理紀錄表。",
                    "evaluateCorrectiveAction":"improve",
                    "evaluateContent":"規劃再確認輸入食品衛生安全之流程，必要時進行矯正措施或修訂食品安全監測計畫",
                    "reviewResults":[],
                },
                "correctionHistories": [
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ],
            }
        ],
        "nextInspectionFocuses":[
            {"nextInspectionFocus":"原製造廠最近一年內出具，並載明所有原料、食品添加物之詳細名稱及含量。"},
            {"nextInspectionFocus":"確認產品成分配方是否符合輸入國家的管理規範。"},
            {"nextInspectionFocus":"版本中移除最重要的複方添加物查驗登記以及基改食品透明標示。"}
        ],
        "newAttentions": [
            {"otherAttention": "提醒客戶其他注意事項....."}
        ],
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "lotNo":"2019-08-03-2",
                "model":"LC-2K004"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "unqualifiedReason":"賽滅寧0.5PPM(0.1PPM)",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "lotNo":"2018007",
                "model":"HFT-40"
            }
        ],
    },
    {
        "uuid": "21",
        "createdOn": "2021-08-21T08:20:10.000Z",
        "appType": "initial",
        "phase": "writtenReview",
        "activity": "writtenReview_S20",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080221",
        "followUpRequests":[
            {
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流",
                "reply": "每週已加強清潔次數",
                "attachments": [],
                "reviewRecords":[
                    {"notifiedDate": "2021-10-22T08:20:10.000Z" ,"incompatibleComment": "描述規劃方案", "customerReply": "規劃加強清潔次數", "replyDate": "2021-10-23T08:20:10.000Z", "carNo": "INS001-01", "estimatedImprovementDate": "2021-12-10"},
                    {"notifiedDate": "2021-10-24T08:20:10.000Z" ,"incompatibleComment": "提供實際實施日期", "customerReply": "預計2021/11開始實施", "replyDate": "2021-10-26T08:20:10.000Z", "carNo": "INS001-02", "estimatedImprovementDate": "2021-12-12"}
                ],
                "rejectReviewers": [
                    {"reviewer": "陳委員", "reviewResult": "同意", "reviewExplanation": ""},
                    {"reviewer": "林委員", "reviewResult": "不同意", "reviewExplanation": "請再提供改善紀錄"}
                ]
            },
            {
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "comment":"申請商應具結品名絕無仿冒或影射他人註冊商標之. 嫌，否則除應自負法律責任及一切損失外，並逕由本部公告. 註銷許可證",
                "reply": "已根據要求調整, 詳見附件說明",
                "attachments": [],
                "reviewRecords":[
                    {"notifiedDate": "2021-10-22T08:20:10.000Z" ,"incompatibleComment": "描述規劃方案", "customerReply": "規劃加強清潔次數", "replyDate": "2021-10-23T08:20:10.000Z", "carNo": "INS001-01", "estimatedImprovementDate": "2021-12-10"},
                    {"notifiedDate": "2021-10-24T08:20:10.000Z" ,"incompatibleComment": "提供實際實施日期", "customerReply": "預計2021/11開始實施", "replyDate": "2021-10-26T08:20:10.000Z", "carNo": "INS001-02", "estimatedImprovementDate": "2021-12-12"}
                ],"rejectReviewers": [
                    {"reviewer": "王委員", "reviewResult": "同意", "reviewExplanation": ""},
                    {"reviewer": "張委員", "reviewResult": "不同意", "reviewExplanation": "請再提供改善紀錄"}
                ]
            },
            {
                "observation":"碳酸鈣550g/包,未涵蓋使用範圍",
                "comment":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制",
                "reply": "已修改",
                "attachments": [],
                "reviewRecords":[
                    {"notifiedDate": "2021-10-22T08:20:10.000Z" ,"incompatibleComment": "描述規劃方案", "customerReply": "規劃加強清潔次數", "replyDate": "2021-10-23T08:20:10.000Z", "carNo": "INS001-01", "estimatedImprovementDate": "2021-12-10"},
                    {"notifiedDate": "2021-10-24T08:20:10.000Z" ,"incompatibleComment": "提供實際實施日期", "customerReply": "預計2021/11開始實施", "replyDate": "2021-10-26T08:20:10.000Z", "carNo": "INS001-02", "estimatedImprovementDate": "2021-12-12"}
                ],"rejectReviewers": [
                    {"reviewer": "王委員", "reviewResult": "同意", "reviewExplanation": ""},
                    {"reviewer": "張委員", "reviewResult": "不同意", "reviewExplanation": "請再提供改善紀錄"}
                ]
            }]
    },
    {
        "uuid": "22",
        "createdOn": "2021-08-22T08:20:10.000Z",
        "appType": "initial",
        "phase": "writtenReview",
        "activity": "writtenReview_S30",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080222",
        "followUpRequests": [
            {
                "observation":"廠外環境污染源現況與申請資料描述不一致",
                "comment":"眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流",
                "reply": "我知道了",
                "attachments": [],
                "reviewRecords":[
                    {"notifiedDate": "2021-10-22T08:20:10.000Z" ,"incompatibleComment": "描述規劃方案", "customerReply": "規劃加強清潔次數", "replyDate": "2021-10-23T08:20:10.000Z", "carNo": "INS001-01", "estimatedImprovementDate": "2021-12-10"},
                    {"notifiedDate": "2021-10-24T08:20:10.000Z" ,"incompatibleComment": "提供實際實施日期", "customerReply": "預計2021/11開始實施", "replyDate": "2021-10-26T08:20:10.000Z", "carNo": "INS001-02", "estimatedImprovementDate": "2021-12-12"}
                ]
            },
            {
                "observation":"原料相關證明文件或檢驗報告可與使用原料來源沒有勾稽",
                "comment":"申請商應具結品名絕無仿冒或影射他人註冊商標之. 嫌，否則除應自負法律責任及一切損失外，並逕由本部公告. 註銷許可證",
                "reply": "我知道了",
                "attachments": [],
                "reviewRecords":[
                    {"notifiedDate": "2021-10-22T08:20:10.000Z" ,"incompatibleComment": "描述規劃方案", "customerReply": "規劃加強清潔次數", "replyDate": "2021-10-23T08:20:10.000Z", "carNo": "INS001-01", "estimatedImprovementDate": "2021-12-10"},
                    {"notifiedDate": "2021-10-24T08:20:10.000Z" ,"incompatibleComment": "提供實際實施日期", "customerReply": "預計2021/11開始實施", "replyDate": "2021-10-26T08:20:10.000Z", "carNo": "INS001-02", "estimatedImprovementDate": "2021-12-12"}
                ]
            }
        ]
    },
    {
        "uuid": "23",
        "createdOn": "2021-08-23T08:20:10.000Z",
        "appType": "initial",
        "phase": "certificate",
        "activity": "certificate_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080223",
        "contractType": "two-party",
        "certificate": true,
        "certificateExpiredDate": "2022-12-02T08:20:10.000Z",
        "certificateNo": "TIC-0001-01",
        "productionDate": "2021-10-01T08:20:10.000Z"
    },
    {
        "uuid": "24",
        "createdOn": "2021-08-24T08:20:10.000Z",
        "appType": "initial",
        "phase": "certificate",
        "activity": "certificate_S20",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080224",
        "contractType": "two-party",
        "certificate": true,
        "certificateNo": "TIC-0120",
        "productionDate": "2022-11-18T08:20:10.000Z",
        "certificateExpiredDate": "2022-12-02T08:20:10.000Z",
    },
    {
        "uuid": "25",
        "createdOn": "2021-08-25T08:20:10.000Z",
        "appType": "initial",
        "phase": "reviewArrangement",
        "activity": "reviewArrangement_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080225",
        "sampling":"Y",
        "onSiteInspection": "Y",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            }
        ],
    },
    {
        "uuid": "26",
        "createdOn": "2021-08-26T08:20:10.000Z",
        "appType": "initial",
        "phase": "reviewArrangement",
        "activity": "reviewArrangement_S20",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080226",
        "inspectionDateOrManDay": "inspectionDate",
        "defaultArea":"north",
        "inspectors":[],
        "sampleInfos":[
            {
                "product":"杏仁玄米餅",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "product":"Natural Benefits 食安生技-椰子汁",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-15T08:20:10.000Z",
            },
            {
                "product":"桂圓四物飲",
                "testType":"原料",
                "testName":"桂圓四物飲-原料1",
                "testItems":"真菌毒素-赭麴毒素A,真菌毒素-棒麴毒素",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":false,
                "samplingDate":"2021-10-21T08:20:10.000Z",
            }

        ],
        "preInspectionInspectors":[
            {
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "samplingDate":"2021-10-15T08:20:10.000Z",
            }
        ],
        "inspectionDates":[
            {
                "inspectionDate":"2021-10-19T08:20:10.000Z"
            }
        ]
    },
    {
        "uuid": "27",
        "createdOn": "2021-08-27T08:20:10.000Z",
        "appType": "initial",
        "phase": "reviewSampling",
        "activity": "reviewSampling_S10",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080227",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ]
    },
    {
        "uuid": "28",
        "createdOn": "2021-08-28T08:20:10.000Z",
        "appType": "initial",
        "phase": "reviewSampling",
        "activity": "reviewSampling_S20",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080228",
        "sampleInfos":[
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ]
    },
    {
        "uuid": "29",
        "createdOn": "2021-08-29T08:20:10.000Z",
        "appType": "initial",
        "phase": "reviewSampling",
        "activity": "reviewSampling_S30",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080229",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ]
    },
    {
        "uuid": "30",
        "createdOn": "2021-08-30T08:20:10.000Z",
        "appType": "initial",
        "phase": "reviewSampling",
        "activity": "reviewSampling_S40",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "台東廠",
        "no": "A21080230",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z"
            }
        ],
        "remainingDays":5
    },
    {
        "uuid":"31",
        "createdOn":"2021-09-01T08:20:10.000Z",
        "appType":"initial",
        "phase":"onsiteReview",
        "activity":"onsiteReview_S10",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080231",
        "plannedInspectionDates":["2021-10-13T08:20:10.000Z","2021-10-15T08:20:10.000Z"],
        "inspectionDates":[
            {"inspectionDate":"2021-10-13T08:00:00.000Z"},
            {"inspectionDate":"2021-10-15T08:00:00.000Z"}
        ]
    },
    {
        "uuid":"32",
        "createdOn":"2021-09-02T08:20:10.000Z",
        "appType":"initial",
        "phase":"onsiteReview",
        "activity":"onsiteReview_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080232",
        "inspectionDates":[
            {"inspectionDate":"2021-10-13"},
            {"inspectionDate":"2021-10-15"}
        ]
    },
    {
        "uuid":"33",
        "createdOn":"2021-09-03T08:20:10.000Z",
        "appType":"initial",
        "phase":"onsiteReview",
        "activity":"onsiteReview_S40",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080233",
        "ncrs":[
            {"carNo":"INS01-01", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"],"observation":"碳酸鈣550g/包,未涵蓋使用範圍","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"carNo":"INS01-02", "regulations":["里仁細則5.10","里仁細則6.2.1"],"observation":"秤添加物電子秤CL-P011(1.8kg),內校300g","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認已修改完成"},
            {"carNo":"INS01-03", "regulations":["里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"],"observation":"2樓洗手消毒亦有多隻果蠅","correctionActionPlan":"1.安全衛生課已會同消毒廠商進行加強消毒。\n2.平時以次氯酸水通水管以減少果蠅孳生風險並加強該作業區的清潔","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認完成改善"}
        ]
    },
    {
        "uuid":"34",
        "createdOn":"2021-09-04T08:20:10.000Z",
        "appType":"followUp",
        "phase":"onsiteReview",
        "activity":"onsiteReview_S50",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司(條列式)",
        "assessmentPlace":"台東廠",
        "no":"A21080234",
        "inspectionReportType": "list",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "ncrs":[
            {"no":"INS01-01", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"],"observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"no":"INS01-02", "regulations":["里仁細則5.10","里仁細則6.2.1"],"observationDesc":"秤添加物電子秤CL-P011(1.8kg),內校300g","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認已修改完成"},
            {"no":"INS01-03", "regulations":["里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"],"observationDesc":"2樓洗手消毒亦有多隻果蠅","correctionActionPlan":"1.安全衛生課已會同消毒廠商進行加強消毒。\n2.平時以次氯酸水通水管以減少果蠅孳生風險並加強該作業區的清潔","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認完成改善"}
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ]
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ]}
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.14",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.15",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.16",
                            "result":"Y"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"5.10"
                        }
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.14",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.15",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.16",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.17",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.18",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.19",
                            "result":"Y"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.3",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.5",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.14",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.15",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.16",
                            "result":"Y"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"9.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "uuid":"35",
        "createdOn":"2021-09-05T08:20:10.000Z",
        "appType":"followUp",
        "phase":"onsiteReview",
        "activity":"onsiteReview_S50",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司(綜合式)",
        "assessmentPlace":"台東廠",
        "no":"A21080235",
        "inspectionReportType": "overall",
        "inspectionContent":{
            "standard":"leezen",
            "inspectionItems":[
                {"productionLine":"line1", "products":["Natural Benefits 食安生技-椰子汁"]},
                {"productionLine":"line2", "products":["杏仁玄米餅","核桃酥"]}
            ],
            "inspectionScope":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制、原料查驗、相關檢驗報告與紀錄表單核對等，及前次所列查驗重點之執行狀況確認"
        },
        "inspectionResult":{
            "previousNcrs":[
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"03-3",
                    "observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍"
                },
                {
                    "appNo":"A20080111",
                    "type":"secondary",
                    "inspectionItem":"06-1",
                    "observationDesc":"評鑑產品之評鑑場所場區環境與衛生管理、製程與品質管制"
                }
            ],
            "leezenRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"豆蓉粉(新版)",
                    "storageCondition":"roomTemperature",
                    "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/03/19(此批非里仁使用)",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"美國加州杏仁果",
                    "storageCondition":"roomTemperature",
                    "composition":"樹薯澱粉、水(原料)",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "composition":"植物油脂(菜籽油)、洋蔥、葡萄糖、抗氧化劑(維生素C、混合濃縮生育醇)",
                    "domesticVendor":"爾邦得有限公司",
                    "importer":"爾邦得有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"槽車運送日期2021/09/14(保存期限3個月)，平均約1個月左右進貨一次，\n" +
                        "當天使用有效日期2021.11.17(8/17進貨)",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"4",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"RPAC,LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":4,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"5",
                    "name":"美國加州杏仁果",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"信和股份有限公司",
                    "importer":"信和股份有限公司",
                    "manufacturer":"VANN FAMLLY ORCHARDS",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":5,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"6",
                    "name":"甜扁桃仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"7",
                    "name":"帶皮杏仁粒",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"昇祥股份有限公司",
                    "importer":"昇祥股份有限公司",
                    "manufacturer":"美國加州皮爾農場公司",
                    "originPlace":"美國加州",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":7,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"8",
                    "name":"有機生糙米粉(台灣)",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"9",
                    "name":"精製椰子油",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"禾發實業有限公司",
                    "importer":"禾發實業有限公司",
                    "manufacturer":"OLEO-FATS, INCORPORATED",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":9,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"10",
                    "name":"杏仁細粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"迦得貿易實業有限公司",
                    "importer":"迦得貿易實業有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"菲律賓",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":10,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"11",
                    "name":"杏仁粉(細)",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"12",
                    "name":"混合濃縮生育醇",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信意企業股份有限公司",
                    "importer":"信意企業股份有限公司",
                    "manufacturer":"CARGILL INCORPORATED",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                    "processingAid":"N",
                    "accessory":"N",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ],
            "tseyueRawMaterials":[
                {
                    "id":"1",
                    "type":"material",
                    "name":"玉米粉",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"乖乖",
                    "importer":"",
                    "manufacturer":"乖乖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "validityAndSituation":"有效日期：2022/3/15",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"2",
                    "type":"material",
                    "name":"精製特砂",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"台糖",
                    "manufacturer":"台糖",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "validityAndSituation":"有效日期：2023/04/18",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                },
                {
                    "id":"3",
                    "name":"二次精製軟棕油",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"福懋油脂",
                    "manufacturer":"福懋油脂",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":3,
                    "validityAndSituation":"有效日期：2023/07/09",
                    "productNames": ["杏仁玄米餅", "核桃酥"],
                }
            ]
        },
        "ncrs":[
            {"no":"INS01-01", "regulations":["里仁細則5.4","慈悅第三部分 評鑑作業流程2.3.4.2"],"observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"no":"INS01-02", "regulations":["里仁細則5.10","里仁細則6.2.1"],"observationDesc":"秤添加物電子秤CL-P011(1.8kg),內校300g","correctionActionPlan":"修正校驗範圍，使其涵蓋量測範圍","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認已修改完成"},
            {"no":"INS01-03", "regulations":["里仁細則5.10、6.3.1","慈悅第三部分 評鑑作業流程3.3.1"],"observationDesc":"2樓洗手消毒亦有多隻果蠅","correctionActionPlan":"1.安全衛生課已會同消毒廠商進行加強消毒。\n2.平時以次氯酸水通水管以減少果蠅孳生風險並加強該作業區的清潔","estimatedImprovementDate":"2021-07-31T08:20:10.000Z","evaluateCorrectiveAction":"agree","evaluationContent":"確認完成改善"}
        ],
        "inspectionItemInfo":{
            "inspectionDates":[
                {"inspectionDate":"2021-09-13T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"王大同", "role":"lead"},
                        {"inspector":"張小明", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ]
                },
                {"inspectionDate":"2021-09-15T16:00:00.000Z",
                    "inspectors":[
                        {"inspector":"吳小保", "role":"inspector"},
                        {"inspector":"林小花", "role":"observer"}
                    ]}
            ],
            "inspector":{
                "lead":"王大同",
                "inspector":["張小明","吳小保"],
                "observer":["林小花"]
            },
            "inspectionItems":[
                {
                    "section":"01",
                    "items":[
                        {
                            "itemCode":"1.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"1.3",
                            "ncrType":"secondary",
                            "result":"N",
                            "observation":"沒有持續全程在場"
                        },
                        {
                            "itemCode":"1.4",
                            "ncrType":"observation",
                            "result":"N",
                            "observation":"標籤微破損"
                        },
                        {
                            "itemCode":"1.5",
                            "result":"Y"
                        }
                    ]
                },
                {
                    "section":"02",
                    "items":[
                        {
                            "itemCode":"2.1",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.2",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.3",
                            "ncrType":"secondary",
                            "result":"N"
                        },
                        {
                            "itemCode":"2.4",
                            "result":"Y"
                        },
                        {
                            "itemCode":"2.5",
                        }
                    ]
                },
                {
                    "section":"03",
                    "items":[
                        {
                            "itemCode":"3.1"
                        },
                        {
                            "itemCode":"3.2"
                        },
                        {
                            "itemCode":"3.3"
                        },
                        {
                            "itemCode":"3.4"
                        },
                        {
                            "itemCode":"3.5"
                        },
                        {
                            "itemCode":"3.6",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.7",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.8",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.9",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.10",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.11",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.12",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.13",
                            "result":"Y"
                        },
                        {
                            "itemCode":"3.14"
                        }
                    ]
                },
                {
                    "section":"04",
                    "items":[
                        {
                            "itemCode":"4.1"
                        },
                        {
                            "itemCode":"4.2"
                        },
                        {
                            "itemCode":"4.3"
                        },
                        {
                            "itemCode":"4.4"
                        },
                        {
                            "itemCode":"4.5"
                        },
                        {
                            "itemCode":"4.6"
                        },
                        {
                            "itemCode":"4.7"
                        },
                        {
                            "itemCode":"4.8"
                        },
                        {
                            "itemCode":"4.9"
                        },
                        {
                            "itemCode":"4.10"
                        },
                        {
                            "itemCode":"4.11"
                        },
                        {
                            "itemCode":"4.12"
                        },
                        {
                            "itemCode":"4.13"
                        },
                        {
                            "itemCode":"4.14"
                        },
                        {
                            "itemCode":"4.15"
                        },
                        {
                            "itemCode":"4.16"
                        },
                        {
                            "itemCode":"4.17"
                        },
                    ]
                },
                {
                    "section":"05",
                    "items":[
                        {
                            "itemCode":"5.1"
                        },
                        {
                            "itemCode":"5.2"
                        },
                        {
                            "itemCode":"5.3"
                        },
                        {
                            "itemCode":"5.4"
                        },
                        {
                            "itemCode":"5.5"
                        },
                        {
                            "itemCode":"5.6"
                        },
                        {
                            "itemCode":"5.7"
                        },
                        {
                            "itemCode":"5.8"
                        },
                        {
                            "itemCode":"5.9"
                        },
                        {
                            "itemCode":"5.10"
                        },
                    ]
                },
                {
                    "section":"06",
                    "items":[
                        {
                            "itemCode":"6.1"
                        },
                        {
                            "itemCode":"6.2"
                        },
                        {
                            "itemCode":"6.3"
                        },
                        {
                            "itemCode":"6.4"
                        },
                        {
                            "itemCode":"6.5"
                        },
                        {
                            "itemCode":"6.6"
                        },
                        {
                            "itemCode":"6.7"
                        },
                        {
                            "itemCode":"6.8"
                        },
                        {
                            "itemCode":"6.9"
                        },
                        {
                            "itemCode":"6.10"
                        },
                        {
                            "itemCode":"6.11"
                        },
                        {
                            "itemCode":"6.12"
                        },
                        {
                            "itemCode":"6.13"
                        },
                        {
                            "itemCode":"6.14"
                        },
                        {
                            "itemCode":"6.15"
                        },
                        {
                            "itemCode":"6.16"
                        },
                        {
                            "itemCode":"6.17"
                        },
                        {
                            "itemCode":"6.18"
                        },
                        {
                            "itemCode":"6.19"
                        },
                        {
                            "itemCode":"6.20"
                        },
                    ]
                },
                {
                    "section":"07",
                    "items":[
                        {
                            "itemCode":"7.1"
                        },
                        {
                            "itemCode":"7.2"
                        },
                        {
                            "itemCode":"7.3"
                        },
                        {
                            "itemCode":"7.4"
                        },
                        {
                            "itemCode":"7.5"
                        },
                        {
                            "itemCode":"7.6"
                        },
                        {
                            "itemCode":"7.7"
                        },
                        {
                            "itemCode":"7.8"
                        },
                        {
                            "itemCode":"7.9"
                        }
                    ]
                },
                {
                    "section":"08",
                    "items":[
                        {
                            "itemCode":"8.1"
                        },
                        {
                            "itemCode":"8.2"
                        },
                        {
                            "itemCode":"8.3"
                        },
                        {
                            "itemCode":"8.4"
                        },
                        {
                            "itemCode":"8.5"
                        },
                        {
                            "itemCode":"8.6"
                        },
                        {
                            "itemCode":"8.7"
                        },
                        {
                            "itemCode":"8.8"
                        },
                        {
                            "itemCode":"8.9"
                        },
                        {
                            "itemCode":"8.10"
                        },
                        {
                            "itemCode":"8.11"
                        },
                        {
                            "itemCode":"8.12"
                        },
                        {
                            "itemCode":"8.13"
                        },
                        {
                            "itemCode":"8.14"
                        },
                        {
                            "itemCode":"8.15"
                        },
                        {
                            "itemCode":"8.16"
                        },
                        {
                            "itemCode":"8.17"
                        }
                    ]
                },
                {
                    "section":"09",
                    "items":[
                        {
                            "itemCode":"9.1"
                        },
                        {
                            "itemCode":"9.2"
                        },
                        {
                            "itemCode":"9.3"
                        },
                    ]
                }
            ]
        }
    },
    {
        "uuid": "35.5",
        "createdOn": "2021-11-22T08:00:00.000Z",
        "no": "A21111904",
        "customerNo": "00001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "桃園廠",
        "phase": "inspectionArrangement",
        "activity": "independentSampling_S10",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "independentSampling","sampling":"Y",
        "onSiteInspection":"Y",
        "samplingPrinciple":"產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品，如:大包裝中有個別小顆單包裝之乾酪 或奶油、乳脂(奶油球)等，則應至少隨機自兩個大包裝中",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            }
        ],
        "remainingDays":1
    },
    {
        "uuid": "36",
        "createdOn": "2021-11-22T08:00:00.000Z",
        "no": "A21112001",
        "customerNo": "00001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "桃園廠",
        "phase": "inspectionArrangement",
        "activity": "independentSampling_S20",
        "defaultArea":"north",
        "inspectionDateOrManDay": "inspectionDate",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "independentSampling",
        "remainingDays": 1,
        "inspectors":[
            {"role":"lead","area":"north"},
            {"role":"inspector","area":"north"},
            {"role":"trainee","area":"north"},
            {"role":"observer","area":"north"}
        ],
        "sampleInfos":[
            {
                "product":"杏仁玄米餅",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "product":"Natural Benefits 食安生技-椰子汁",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-15T08:20:10.000Z",
            },
            {
                "product":"桂圓四物飲",
                "testType":"原料",
                "testName":"桂圓四物飲-原料1",
                "testItems":"真菌毒素-赭麴毒素A,真菌毒素-棒麴毒素",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":false,
                "samplingDate":"2021-10-21T08:20:10.000Z",
            }
        ],
        "preInspectionInspectors":[
            {
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "samplingDate":"2021-10-15T08:20:10.000Z",
            }
        ],
        "inspectionDates":[
            {
                "inspectionDate":"2021-10-19T08:20:10.000Z"
            }
        ]
    },
    {
        "uuid": "37",
        "createdOn": "2021-11-22T08:00:00.000Z",
        "no": "A21111922",
        "customerNo": "00003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "台東廠",
        "phase": "sampling",
        "activity": "independentSampling_S30",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "independentSampling",
        "remainingDays": 1,
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ]
    },
    {
        "uuid": "38",
        "createdOn": "2021-11-22T08:00:00.000Z",
        "no": "A21111801",
        "customerNo": "01209",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "屏東廠",
        "phase": "sampling",
        "activity": "independentSampling_S40",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "independentSampling",
        "remainingDays": 1,
        "amountDefault": 1000,
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "chargeItems":[
            {
                "item":"transportation",
                "amountDefault":1000,
                "amountModified":1000
            }
        ],
    },
    {
        "uuid": "39",
        "createdOn": "2021-11-22T08:00:00.000Z",
        "no": "A21111709",
        "customerNo": "00036",
        "customerName": "豆之家食品科技股份有限公司",
        "assessmentPlace": "台東廠",
        "phase": "sampling",
        "activity": "independentSampling_S50",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "independentSampling",
        "remainingDays": 1,
        "amountDefault": 1000,
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "chargeItems":[
            {
                "item":"transportation",
                "amountDefault":1000,
                "amountModified":1000
            }
        ],
    },
    {
        "uuid": "40",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120101",
        "violationTypes": ["quality"],
        "phase": "violation",
        "activity": "violation_S10",
        "customerNo": "00011",
        "customerName": "里仁客戶1",
        "assessmentPlace": "台東廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "leezen",
        "noticeType": "improvement",
        "subject": "有關　貴公司申請『里仁與慈悅評鑑標準』乙案，A21120101『違規處理』經本公司審定後決議『限期改善』1週（至2021-12-23），敬請於改善完成後回覆本公司，以免影響  貴公司評鑑資格，敬請 查照。",
        "nonConformanceReport": "1. 杏仁玄米餅/紙袋/盒(500g)等產品，外標示、廣告文宣或網路宣傳未經本公司審核，使用評鑑證書、本公司服務標誌或評鑑標章不符合本公司規定或有誤導消費者之嫌。\n" +
            "2.販賣、展示或廣告『杏仁玄米餅』，未通過評鑑而聲稱為已評鑑產品。\n",
        "noticeAndCorrection": "(一)\t上述違規產品已售出部分應於一日內下架，十日內完成回收(2021/12/20)，違規產品未改正前不得以本公司評鑑名義販售。\n" +
            "(二)\t請盤點所有產品標示、廣告文宣或網路宣傳，於1週內(2021/12/15前)回覆違規原因、矯正說明、下架回收紀錄及預防再發措施等資料；本公司將視情況決定是否派員實地查驗，若需查驗，相關費用將由  貴公司支付。 \n" +
            "(三)\t為延續　貴公司評鑑資格，倘限期內未提出矯正資料且無任何延宕說明者，本公司將依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第3.1.8條「使用評鑑證書、本公司服務標誌或評鑑標章不符合本公司規定或有誤導消費者之嫌，經通知限期改善仍未完成改善者。」條文規定，暫時終止　貴公司全部或部份評鑑資格。\n",
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "41",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120102",
        "violationTypes": ["quality"],
        "phase": "violation",
        "activity": "violation_S10",
        "customerNo": "00012",
        "customerName": "慈悅客戶1",
        "assessmentPlace": "台東廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "tseyue",
        "noticeType": "improvement",
        "subject": "有關　貴公司申請『慈悅評鑑標準』乙案，A21120102『違規處理』經本公司審定後決議『限期改善』1週（至2021-12-23），敬請於改善完成後回覆本公司，以免影響  貴公司評鑑資格，敬請 查照。",
        "nonConformanceReport": "1. 杏仁玄米餅/紙袋/盒(500g)等產品，外標示、廣告文宣或網路宣傳未經本公司審核，使用評鑑證書、本公司服務標誌或評鑑標章不符合本公司規定或有誤導消費者之嫌。\n" +
            "2.販賣、展示或廣告『杏仁玄米餅』，未通過評鑑而聲稱為已評鑑產品。\n",
        "noticeAndCorrection": "(一)\t上述違規產品已售出部分應於一日內下架，十日內完成回收(2021/12/20)，違規產品未改正前不得以本公司評鑑名義販售。\n" +
            "(二)\t請盤點所有產品標示、廣告文宣或網路宣傳，於1週內(2021/12/15前)回覆違規原因、矯正說明、下架回收紀錄及預防再發措施等資料；本公司將視情況決定是否派員實地查驗，若需查驗，相關費用將由  貴公司支付。 \n" +
            "(三)\t為延續　貴公司評鑑資格，倘限期內未提出矯正資料且無任何延宕說明者，本公司將依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第3.1.8條「使用評鑑證書、本公司服務標誌或評鑑標章不符合本公司規定或有誤導消費者之嫌，經通知限期改善仍未完成改善者。」條文規定，暫時終止　貴公司全部或部份評鑑資格。\n",
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "42",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120103",
        "violationTypes": ["mark"],
        "phase": "violation",
        "activity": "violation_S10",
        "customerNo": "00013",
        "customerName": "里仁客戶2",
        "assessmentPlace": "台東廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "leezen",
        "noticeType": "suspend",
        "subject": "有關　貴公司申請『里仁與慈悅評鑑標準』乙案，A21120103『違規處理』經本公司審定後決議『暫時終止』全部/部分評鑑範圍，請依說明事項處理，並於15天內(至2021-12-23前)回覆本公司，以免影響  貴公司評鑑資格，敬請　查照。",
        "nonConformanceReport": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第3.1.7 條: \n" +
            "產品『杏仁玄米餅』(有效日期2022/02/01)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準，或不符合里仁內規",
        "noticeAndCorrection": "(一)\t貴公司於2021/12/30後不可再生產印有評鑑標章之『杏仁玄米餅』產品和宣傳。\n" +
            "(二)\t杏仁玄米餅原料(有效日期2021/12/30)禁止再使用；使用此批原料之產品禁止出貨，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(三)\t產品『杏仁玄米餅』(有效日期2021/12/30)禁止以本公司評鑑名義繼續販售，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(四)\t請於15天內(2021/12/20前)回覆本公司下列資料：\n" +
            "1.\t此批原料流向、不合格原因說明、原料後續處理方式、矯正說明及預防再發措施。\n" +
            "2.\t產品回收紀錄(請詳列產品生產日期、批號、包裝規格、生產數量/重量、銷售對象、回收數量…等)。\n" +
            "3.\t產品違規原因、矯正說明及預防再發措施。\n" +
            "(五)\t本公司收到相關資料後，得派員不定期查驗與檢驗產品/原料，相關費用將由  貴公司支付。\n",
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "43",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120104",
        "violationTypes": ["quality", "mark"],
        "phase": "violation",
        "activity": "violation_S10",
        "customerNo": "00014",
        "customerName": "慈悅客戶2",
        "assessmentPlace": "台東廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "tseyue",
        "noticeType": "suspend",
        "subject": "有關　貴公司申請『慈悅評鑑標準』乙案，A21120104『違規處理』經本公司審定後決議『暫時終止』全部/部分評鑑範圍，請依說明事項處理，並於15天內(至2021-12-23前)回覆本公司，以免影響  貴公司評鑑資格，敬請　查照。",
        "nonConformanceReport": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第3.1.7 條: \n" +
            "產品『杏仁玄米餅』(有效日期2022/02/01)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準，或不符合里仁內規",
        "noticeAndCorrection": "(一)\t貴公司於2021/12/30後不可再生產印有評鑑標章之『杏仁玄米餅』產品和宣傳。\n" +
            "(二)\t杏仁玄米餅原料(有效日期2021/12/30)禁止再使用；使用此批原料之產品禁止出貨，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(三)\t產品『杏仁玄米餅』(有效日期2021/12/30)禁止以本公司評鑑名義繼續販售，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(四)\t請於15天內(2021/12/20前)回覆本公司下列資料：\n" +
            "1.\t此批原料流向、不合格原因說明、原料後續處理方式、矯正說明及預防再發措施。\n" +
            "2.\t產品回收紀錄(請詳列產品生產日期、批號、包裝規格、生產數量/重量、銷售對象、回收數量…等)。\n" +
            "3.\t產品違規原因、矯正說明及預防再發措施。\n" +
            "(五)\t本公司收到相關資料後，得派員不定期查驗與檢驗產品/原料，相關費用將由  貴公司支付。\n",
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "44",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120105",
        "violationTypes": ["quality"],
        "phase": "violation",
        "activity": "violation_S20",
        "customerNo": "00003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "桃園廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "tseyue",
        "noticeType": "suspend",
        "subject": "有關　貴公司申請『慈悅評鑑標準』乙案，A21120104『違規處理』經本公司審定後決議『暫時終止』全部/部分評鑑範圍，請依說明事項處理，並於15天內(至2021-12-23前)回覆本公司，以免影響  貴公司評鑑資格，敬請　查照。",
        "nonConformanceReport": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第3.1.7 條: \n" +
            "產品『杏仁玄米餅』(有效日期2022/02/01)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準，或不符合里仁內規",
        "noticeAndCorrection": "(一)\t貴公司於2021/12/30後不可再生產印有評鑑標章之『杏仁玄米餅』產品和宣傳。\n" +
            "(二)\t杏仁玄米餅原料(有效日期2021/12/30)禁止再使用；使用此批原料之產品禁止出貨，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(三)\t產品『杏仁玄米餅』(有效日期2021/12/30)禁止以本公司評鑑名義繼續販售，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(四)\t請於15天內(2021/12/20前)回覆本公司下列資料：\n" +
            "1.\t此批原料流向、不合格原因說明、原料後續處理方式、矯正說明及預防再發措施。\n" +
            "2.\t產品回收紀錄(請詳列產品生產日期、批號、包裝規格、生產數量/重量、銷售對象、回收數量…等)。\n" +
            "3.\t產品違規原因、矯正說明及預防再發措施。\n" +
            "(五)\t本公司收到相關資料後，得派員不定期查驗與檢驗產品/原料，相關費用將由  貴公司支付。\n",
        "timeComplianceRate": "onTime",
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "45",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120106",
        "violationTypes": ["quality"],
        "phase": "violation",
        "activity": "violation_S30",
        "customerNo": "00003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "新竹廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "tseyue",
        "noticeType": "suspend",
        "subject": "有關　貴公司申請『慈悅評鑑標準』乙案，A21120104『違規處理』經本公司審定後決議『暫時終止』全部/部分評鑑範圍，請依說明事項處理，並於15天內(至2021-12-23前)回覆本公司，以免影響  貴公司評鑑資格，敬請　查照。",
        "nonConformanceReport": "依慈悅國際評鑑作業手冊第三部份評鑑程序之「評鑑不符合事項指導說明」第3.1.7 條: \n" +
            "產品『杏仁玄米餅』(有效日期2022/02/01)檢出評鑑等級所訂禁止添加OOO之成分，或不符合中央主管機關公告之衛生標準，或不符合里仁內規",
        "noticeAndCorrection": "(一)\t貴公司於2021/12/30後不可再生產印有評鑑標章之『杏仁玄米餅』產品和宣傳。\n" +
            "(二)\t杏仁玄米餅原料(有效日期2021/12/30)禁止再使用；使用此批原料之產品禁止出貨，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(三)\t產品『杏仁玄米餅』(有效日期2021/12/30)禁止以本公司評鑑名義繼續販售，已售出產品應於一日內下架，十日內完成回收。\n" +
            "(四)\t請於15天內(2021/12/20前)回覆本公司下列資料：\n" +
            "1.\t此批原料流向、不合格原因說明、原料後續處理方式、矯正說明及預防再發措施。\n" +
            "2.\t產品回收紀錄(請詳列產品生產日期、批號、包裝規格、生產數量/重量、銷售對象、回收數量…等)。\n" +
            "3.\t產品違規原因、矯正說明及預防再發措施。\n" +
            "(五)\t本公司收到相關資料後，得派員不定期查驗與檢驗產品/原料，相關費用將由  貴公司支付。\n",
        "timeComplianceRate": "onTime",
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "46",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120108",
        "violationTypes": ["quality"],
        "phase": "violation",
        "activity": "violation_S50",
        "customerNo": "00003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "彰化廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "tseyue",
        "replyContent": "來自新加坡，多次獲得《The Ramen Rater》全球最佳泡麵的頂級品牌。 以新鮮香草、香料和蝦米調製叻沙湯底，道地濃郁的南洋娘惹風味。 以純天然香料調味製作，不然人工防腐劑和色素，享受美味無後顧之憂。",
        "correctionReplyHistory": [
            {"supplementNotifyingDate": "2022-01-17T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-24T00:00:00.000Z", "replyContent": "回覆內容............"},
            {"supplementNotifyingDate": "2022-01-18T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-25T00:00:00.000Z", "replyContent": "回覆內容............"},
            {"supplementNotifyingDate": "2022-01-19T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-26T00:00:00.000Z", "replyContent": "回覆內容............"},
        ],
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },
    {
        "uuid": "47",
        "createdOn": "2021-12-10T08:00:00.000Z",
        "no": "A21120109",
        "violationTypes": ["quality"],
        "phase": "violation",
        "activity": "violation_S60",
        "customerNo": "00003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "雲林廠",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "appType": "violation",
        "remainingDays": 1,
        "noticeVersion": "tseyue",
        "replyContent": "來自新加坡，多次獲得《The Ramen Rater》全球最佳泡麵的頂級品牌。 以新鮮香草、香料和蝦米調製叻沙湯底，道地濃郁的南洋娘惹風味。 以純天然香料調味製作，不然人工防腐劑和色素，享受美味無後顧之憂。",
        "correctionReplyHistory": [
            {"supplementNotifyingDate": "2022-01-17T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-24T00:00:00.000Z", "replyContent": "回覆內容............"},
            {"supplementNotifyingDate": "2022-01-18T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-25T00:00:00.000Z", "replyContent": "回覆內容............"},
            {"supplementNotifyingDate": "2022-01-19T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-26T00:00:00.000Z", "replyContent": "回覆內容............"},
        ],
        "violationData": {
            "violationTypes": ["quality"],
            "source":"selfMarketTest",
            "appNo": "A21012504",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核"
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "effectiveDate": "2023-02-09T00:00:00.000Z",
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)"
                }
            ],
            "samplingUnqualifiedData": [
                {
                    "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                    "testResult": "unqualified",
                    "reasonForUnqualified": "農藥殘留:賽滅寧0.5ppm(法規0.1ppm)",
                }
            ]
        },
    },{
        "uuid":"48",
        "createdOn":"2021-08-12T08:20:10.000Z",
        "appType":"irregular",
        "phase":"inspectionArrangement",
        "activity":"inspectionArrangement_S10",
        "customerNo":"00003",
        "customerName":"黑松股份有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080504",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "sampling":"Y",
        "onSiteInspection":"Y",
        "inspectionNote": "提醒稽核員下次查驗注意事項......\n......\n......",
        "samplingPrinciple":"產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品，如:大包裝中有個別小顆單包裝之乾酪 或奶油、乳脂(奶油球)等，則應至少隨機自兩個大包裝中",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year"
            }
        ],
        "remainingDays":1,
        "irregularInfos": {
            "source": "selfStart",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "description": "不定追說明......\n......\n......",
            "inspectionTiming": "Y",
            "creator": "王小白",
            "createdOn": "2021-11-10T00:00:00.000Z",
            "inspectionItems": [
                {"productionLine": "line1", "products": ["Natural Benefits 食安生技-椰子汁","Natural Benefits 純在-蔬菜綜合果汁"]},
                {"productionLine": "line2", "products": ["杏仁玄米餅","馬賽克餅乾","巧克力豆餅乾"]}
            ]
        },
        "inspectionItems": [
            {"productionLine": "line1", "products": ["Natural Benefits 食安生技-椰子汁","Natural Benefits 純在-蔬菜綜合果汁"]},
            {"productionLine": "line2", "products": ["杏仁玄米餅","馬賽克餅乾","巧克力豆餅乾"]}
        ]
    },
    {
        "uuid":"49",
        "urgent":true,
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"irregular",
        "phase":"inspectionArrangement",
        "activity":"inspectionArrangement_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080505",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "defaultArea":"north",
        "inspectionDateOrManDay": "inspectionDate",
        "inspectors":[],
        "inspectionNote": "提醒稽核員下次查驗注意事項......\n......\n......",
        "sampleInfos":[
            {
                "product":"杏仁玄米餅",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "product":"Natural Benefits 食安生技-椰子汁",
                "testType":"成品",
                "testName":"杏仁玄米餅",
                "testItems":"農藥殘留",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":true,
                "samplingDate":"2021-10-15T08:20:10.000Z",
            },
            {
                "product":"桂圓四物飲",
                "testType":"原料",
                "testName":"桂圓四物飲-原料1",
                "testItems":"真菌毒素-赭麴毒素A,真菌毒素-棒麴毒素",
                "testCompany":"SGS",
                "paymentUnit":"里仁",
                "samplingTiming":false,
                "samplingDate":"2021-10-21T08:20:10.000Z",
            }
        ],
        "preInspectionInspectors":[
            {
                "samplingDate":"2021-10-13T08:20:10.000Z",
            },
            {
                "samplingDate":"2021-10-15T08:20:10.000Z",
            }
        ],
        "inspectionDates":[
            {
                "inspectionDate":"2021-10-19T08:20:10.000Z"
            }
        ],
        "irregularInfos": {
            "source": "reviewMeeting",
            "appNo": "21122101",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "inspectionTiming": "Y",
        },
    },
    {
        "uuid":"50",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"irregular",
        "phase":"sampling",
        "activity":"sampling_S10",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080506",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ],
        "irregularInfos": {
            "source": "selfStart",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "description": "不定追說明......\n......\n......",
            "inspectionTiming": "Y",
            "creator": "王小白",
            "createdOn": "2021-11-10T00:00:00.000Z",
            "inspectionItems": [
                {"productionLine": "line1", "products": ["Natural Benefits 食安生技-椰子汁","Natural Benefits 純在-蔬菜綜合果汁"]},
                {"productionLine": "line2", "products": ["杏仁玄米餅","馬賽克餅乾","巧克力豆餅乾"]}
            ]
        },
    },
    {
        "uuid":"51",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"irregular",
        "phase":"sampling",
        "activity":"sampling_S20",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080507",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "samplingPrinciple":"產品每單位完整包裝重量(體積)遠小於單次微生物檢驗所需之取樣量， 且不適合以稀釋方式處理者，其單件之採樣量(重量/體積)應酌予增加， 儘量取至檢驗需求之最低取樣量1以上；如為大包裝中之個別小包裝， 且係以該大包裝販賣之產品，如:大包裝中有個別小顆單包裝之乾酪 或奶油、乳脂(奶油球)等",
        "sampleInfos":[
            {
                "product":"07",
                "testType":"finishedGood",
                "testName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "finishedGoodTestName":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國"
            }
        ],
        "irregularInfos": {
            "source": "reviewMeeting",
            "appNo": "21122101",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "inspectionTiming": "Y",
        },
    },
    {
        "uuid":"52",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"irregular",
        "phase":"sampling",
        "activity":"sampling_S30",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080501",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z",
                "samplingInstruction":"於廠內連續批次生產時，可指為一個批次生產產品中抽取的一個單位 包裝或一次採樣盛裝量"
            }
        ],
        "irregularInfos": {
            "source": "selfStart",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "description": "不定追說明......\n......\n......",
            "inspectionTiming": "Y",
            "creator": "王小白",
            "createdOn": "2021-11-10T00:00:00.000Z",
            "inspectionItems": [
                {"productionLine": "line1", "products": ["Natural Benefits 食安生技-椰子汁","Natural Benefits 純在-蔬菜綜合果汁"]},
                {"productionLine": "line2", "products": ["杏仁玄米餅","馬賽克餅乾","巧克力豆餅乾"]}
            ]
        },
    },
    {
        "uuid":"53",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"irregular",
        "phase":"sampling",
        "activity":"sampling_S40",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080508",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "sampleInfos":[
            {
                "product":"01",
                "testType":"finishedGood",
                "testName":"杏仁玄米餅",
                "finishedGoodTestName":"杏仁玄米餅",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"台東廠",
                "originPlace":"台灣",
                "testResult":"qualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-12-31T08:20:10.000Z",
                "packingSpec":"200g/盒"
            },
            {
                "product":"03",
                "testType":"rawMaterial",
                "testName":"桂圓四物飲-原料1",
                "rawMaterialTestName":"01",
                "testItems":[{testItem:"01"},{testItem:"03", details:["0301","0303"]}],
                "testCompany":"sgs",
                "paymentUnit":"leezen",
                "samplingTiming":true,
                "samplingFrequency":"year",
                "sampleManufacture":"原料1製造商",
                "originPlace":"美國",
                "testResult":"unqualified",
                "SamplingDate":"2021-09-13T08:20:10.000Z",
                "sampleExpireDate":"2022-09-13T08:20:10.000Z"
            }
        ],
        "remainingDays":5,
        "irregularInfos": {
            "source": "reviewMeeting",
            "appNo": "21122101",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "inspectionTiming": "Y",
        },
    },
    {
        "uuid":"54",
        "createdOn":"2021-08-13T08:20:10.000Z",
        "appType":"irregular",
        "phase":"inspection",
        "activity":"inspection_S10",
        "customerNo":"00001",
        "customerName":"中農粉絲有限公司",
        "assessmentPlace":"台東廠",
        "no":"A21080509",
        "notifiedDate": "2021-12-28T00:00:00.000Z",
        "plannedInspectionDates":["2021-10-13T08:20:10.000Z","2021-10-15T08:20:10.000Z"],
        "inspectionDates":[
            {"inspectionDate":"2021-10-13T08:00:00.000Z"},
            {"inspectionDate":"2021-10-15T08:00:00.000Z"}
        ],
        "inspectionItems": [],
        "irregularInfos": {
            "source": "selfStart",
            "keyPoint": "提醒稽核員下次查驗注意事項......\n......\n......",
            "description": "不定追說明......\n......\n......",
            "inspectionTiming": "Y",
            "creator": "王小白",
            "createdOn": "2021-11-10T00:00:00.000Z",
            "inspectionItems": [
                {"productionLine": "line1", "products": ["Natural Benefits 食安生技-椰子汁","Natural Benefits 純在-蔬菜綜合果汁"]},
                {"productionLine": "line2", "products": ["杏仁玄米餅","馬賽克餅乾","巧克力豆餅乾"]}
            ]
        },
    },
]

export default assessmentInboxes;